import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue, ODriveAxisState, ODriveBrakeFlag, ODriveError, getActiveErrors } from './utils';

export default function ODrive({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>ODrive</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}{d.frequency && <> - {formatValue(d.frequency, 1)} Hz</>}
          <p style={{ marginLeft: '1em' }}>
            {`${ODriveAxisState[d.axis_state] || d.axis_state}`}<br />
            {`Velocity: ${formatValue(d.velocity * 60 / 8, 0)} rpm`}<br />
            {`Position: ${formatValue(d.position, 1)} turns`}<br />
            {`Torque: ${formatValue(d.torque_estimate, 1)} Nm`}<br />
            {`Voltage: ${formatValue(d.bus_voltage, 1)} V`}<br />
            {`Current: ${formatValue(d.bus_current, 1)} A`}<br />
            {`Power: ${formatValue(d.bus_voltage * d.bus_current, 1)} W`}<br />
            {`Motor temperature: ${formatValue(d.temperature_motor, 0)} °C`}<br />
            {/* Brake resistor, only sent by firmware that reads brake_resistor0 */}
            {d.brake_duty != null &&
              <>{`Brake duty: ${formatValue(d.brake_duty * 100, 0)} %`}<br /></>}
            {d.brake_chopper_temperature != null &&
              <>{`Brake chopper temperature: ${formatValue(d.brake_chopper_temperature, 0)} °C`}<br /></>}
            {d.brake_flags != null && (d.brake_flags & ODriveBrakeFlag.ARMED) === 0 &&
              <>Brake chopper disarmed<br /></>}
            {(d.brake_flags & ODriveBrakeFlag.SATURATED) > 0 &&
              <>Brake saturated<br /></>}
            {d.error_code !== ODriveError.ERROR_NONE && <div>Error: {getActiveErrors(ODriveError, d.error_code)?.join(', ')}</div>}
          </p>
        </div>
      ))}
    </Item>
  );
}
